export default {
    type: 'numeric',
    format: {
        decimals: 3,
        min: 0,
        max: 10
    },
    default: {
        logic: 'min',
        rating: 'value'
    },
    setting: {
        logic: ['match', 'min', 'max', 'range', 'tolerance'],
        rating: ['value', 'band']
    },
    link: {},
    usage: {
        owners: ['user'],
        results: ['collection','play','rating','game']
    },
    lang: {
        name: 'User Rating',
        category: ['User', 'Ratings'],
        description: 'User rating given to the game.',
        summarise: {
            prefix: 'User rating'
        }
    },
    rules: {
        linked: [],
        legacy: ['rating.user']
    }
}